import React, { FC } from 'react'

import { useTheme, Box } from '@mui/material'

export const BarLine: FC<{
  bgColor: string
  percentage: number
}> = ({ bgColor, percentage }) => {
  const { spacing } = useTheme()

  return (
    <Box height={spacing(2.4)} display="flex" alignItems="center">
      <Box
        height={spacing(1.5)}
        borderRadius={spacing(0.25)}
        bgcolor={bgColor}
        width={`${percentage}%`}
        sx={{
          printColorAdjust: 'exact',
        }}
      />
    </Box>
  )
}
